module.exports = __webpack_public_path__ + "img/gamified-icon.5c31f01c.svg";